import React, { useState } from 'react';
import styled from 'styled-components';

const EmailGrabberTitle = styled.h2 `
  font-size: 40px;
  line-height: 1.25;
  text-align: left;
  margin-bottom: 15px;
  color: ${p => p.titleColor};
  font-weight: 500;
  text-transform: uppercase;

  @media (max-width: 995px){
    font-size: 4vw;
    text-align: center;
  }

  @media (max-width: 600px){
    font-size: 5vw;
    margin-bottom: 10px;
    text-align: center;
  }
`;

const EmailGrabberText = styled.p `
    font-size: 22px;
    color: ${p => p.textColor};
    text-align: left;
    margin-bottom: 30px;

    @media (max-width: 995px){
        text-align: center;        
    }

    @media (max-width: 600px){
        margin-bottom: 20px;
        font-size: 17px;
      }
`;

const EmailGrabberForm = styled.form `
    width: 100%;
    max-width: 550px;
    position: relative;
    display: flex;

    @media (max-width: 995px){
        margin: 0 auto;
    }
`;

const EmailGrabberInput = styled.input `
    appearance: none;
    border-radius: 0;
    width: calc(100% - 110px);
    font-size: 20px;
    height: 60px;
    padding: 0 15px;
    border: 2px solid ${p=>p.inputBorderColor};;
    background: ${p=>p.inputBackground};
    color: ${p=>p.inputColor};

    &:focus {
        outline-width: 0px;
        border-color: ${p=>p.inputBorderColorFocus};
    }

    ::placeholder { color: ${p=>p.inputPlaceholderColor}; }    
    :-ms-input-placeholder { color: ${p=>p.inputPlaceholderColor}; }    
    ::-ms-input-placeholder { color: ${p=>p.inputPlaceholderColor}; }

    @media (max-width: 600px){
        font-size: 18px;
        width: calc(100% - 95px);
        padding: 0 10px;
    }

    @media (max-width: 350px){
        width: 100%;
    }
`;

const EmailGrabberSubmit = styled.input `
    appearance: none;
    border-radius: 0;
    margin: 0;
    height: 60px;
    background: ${p=>p.buttonBackground[0]||p.buttonBackground};
    background: linear-gradient(180deg, ${p=>Array.isArray(p.buttonBackground)?p.buttonBackground[0]:p.buttonBackground} 1%,${p=>Array.isArray(p.buttonBackground)?p.buttonBackground[1]:p.buttonBackground});
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="${p=>Array.isArray(p.buttonBackground)?p.buttonBackground[0]:p.buttonBackground}", endColorstr="${p=>Array.isArray(p.buttonBackground)?p.buttonBackground[0]:p.buttonBackground}", GradientType=0);
    color: ${p=>p.buttonColor};
    border: 0;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 18px;
    cursor: pointer;

    &:focus {
        outline-width: 0px;
    }

    @media (hover: hover) {
        &:hover {
            background: ${p=>p.buttonBackgroundHover[0]||p.buttonBackgroundHover};
            background: linear-gradient(180deg, ${p=>Array.isArray(p.buttonBackgroundHover)?p.buttonBackgroundHover[0]:p.buttonBackgroundHover} 1%,${p=>Array.isArray(p.buttonBackgroundHover)?p.buttonBackgroundHover[1]:p.buttonBackgroundHover});
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="${p=>Array.isArray(p.buttonBackgroundHover)?p.buttonBackground[0]:p.buttonBackgroundHover}", endColorstr="${p=>Array.isArray(p.buttonBackgroundHover)?p.buttonBackgroundHover[0]:p.buttonBackgroundHover}", GradientType=0);
            color: ${p=>p.buttonColorHover};
        }
    }

    @media (max-width: 600px){
        width: 95px;
    }

    @media (max-width: 350px){
        width: auto;
        font-size: 5vw;
        padding: 0 2%;
    }
`;

const EmailGrabberConfirmationTitle = styled(EmailGrabberTitle)
`
    margin-bottom: 0;
`;

const EmailGrabber = ({
    maropostID,
    title = "",
    titleColor = "#fff",
    text = "",
    textColor = "#fff",
    buttonText = 'Submit',
    placeholderText = 'Email Address',
    buttonBackground = "#01f4e0",
    buttonBackgroundHover = "#09c6cd",
    buttonColor = "#000",
    buttonColorHover = "#000",
    inputBackground = "#fff",
    inputColor = "#000",
    inputPlaceholderColor = "#A6A6A6",
    inputBorderColor = "transparent",
    inputBorderColorFocus = "#01f4e0",
    confirmText = 'Thanks! Please check your email for confirmation'
}) => {
    const [inputValue, setInputValue] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleInputValueChange = e => {
        setInputValue(e.target.value);
    };

    const handleFormSubmit = () => {
        setTimeout(() => {
            setFormSubmitted(!formSubmitted);
        }, 200);
    };

    return (
        <div>
    			<iframe src="" name="maropostcall" title="email" style={{ display: 'none' }} />
    			{!formSubmitted ? (
    				<div>
    					<EmailGrabberTitle titleColor={titleColor} dangerouslySetInnerHTML={{__html: title}} />
    					<EmailGrabberText textColor={textColor} dangerouslySetInnerHTML={{__html: text}} />
    					<EmailGrabberForm
    						action={`https://api.maropost.com/accounts/1170/forms/${maropostID}`}
    						method="post"
    						target="maropostcall"
    						onSubmit={() => {
    						    handleFormSubmit();
    						    return true;
    					    }}
    					>
                            <EmailGrabberInput
                                include_blank="true"
                                start_year="2018"
                                type="email"
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                required
                                name="contact_fields[email]"
                                id="email"
                                placeholder={placeholderText}
                                value={inputValue}
                                onChange={handleInputValueChange}
                                inputColor= {inputColor}
                                inputBackground= {inputBackground}
                                inputPlaceholderColor= {inputPlaceholderColor}
                                inputBorderColor= {inputBorderColor}
                                inputBorderColorFocus= {inputBorderColorFocus}
                            />
                            <EmailGrabberSubmit 
                                id="submit" 
                                type="submit"
                                name="commit"
                                value={buttonText}
                                buttonBackground={buttonBackground}
                                buttonBackgroundHover= {buttonBackgroundHover}
                                buttonColor={buttonColor}
                                buttonColorHover= {buttonColorHover}
                            />
    				    </EmailGrabberForm>
    				</div>
    			) : (
    				<EmailGrabberConfirmationTitle titleColor={titleColor}>
    					{confirmText}
    				</EmailGrabberConfirmationTitle>
    			)}
    		</div>
    );
};

export default EmailGrabber;
